import { Json } from '../types/types';

export const get = (state: Json, xpath: string | string[]) => {
  try {
    const path = Array.isArray(xpath) ? xpath : xpath.split('.');
    let cursor = state;

    for (const key of path) {
      cursor = cursor[key];
    }

    return cursor;
  } catch (e) {
    return undefined;
  }
};

export const set = (state: Json, xpath: string | string[], value: any) => {
  const path = Array.isArray(xpath) ? xpath : xpath.split('.');
  const lastKey = path.pop();
  let obj = state;

  for (const key of path) {
    if (!obj[key]) {
      obj[key] = {};
    }
    obj = obj[key];
  }

  if (lastKey === undefined) {
    return undefined;
  }

  obj[lastKey] = value;

  return state;
};

export const patch = (state: Json, xpath: string | string[], value: Json) => {
  const path = Array.isArray(xpath) ? xpath : xpath.split('.');
  const lastKey = path.pop();
  let obj = state;

  for (const key of path) {
    if (!obj[key]) {
      obj[key] = {};
    }
    obj = obj[key];
  }

  if (lastKey === undefined) {
    return undefined;
  }

  obj[lastKey] = {
    ...obj[lastKey],
    ...value,
  };

  return state;
};

export const del = (state: Json, xpath: string | string[]) => {
  const path = Array.isArray(xpath) ? xpath : xpath.split('.');
  const lastKey = path.pop();
  let obj = state;

  for (const key of path) {
    if (!obj[key]) {
      obj[key] = {};
    }
    obj = obj[key];
  }

  if (lastKey === undefined) {
    return undefined;
  }

  delete obj[lastKey];

  return state;
};

export const clone = <T>(state: T): T => {
  return JSON.parse(JSON.stringify(state));
};

export const parseKey = (key: string, variables: Json = {}) => {
  const regex = /\[(.*?)\]/g;
  const matches = regex.exec(key);

  if (!matches) {
    return key;
  }

  const varName = matches[1];
  const value = variables[varName];

  return value;
};

export const parseXpath = (xpath: string | string[], variables: Json = {}) => {
  const path = Array.isArray(xpath) ? xpath : xpath.split('.');
  return path.map((key) => parseKey(key, variables));
};
